<div class="container"  *ngIf='blogs$ | async as blogs'>
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">Latest Posts</h2>

  <div class="spacer-60"></div>

  <div class="row blog-wrapper">
    <div class="col-md-4" *ngFor='let blog of blogs.reverse()'>
      <app-blog
      [blog]='blog'>

      </app-blog>
    </div>
  </div>
</div>

